import type * as React from 'react';

import { css, html } from 'react-strict-dom';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';

type Props = {
  /** Destructive or secondary action, kept to the left. */
  left?: React.ReactNode;
  children: React.ReactNode;
};

/**
 * The bar pinned to the bottom of a Service Order screen, holding the page's
 * one Save.  Nothing is written while you type; the Save is the only moment
 * the screen talks to the server.
 */
export default function SaveBar({ left, children }: Props) {
  return (
    <html.div style={styles.bar}>
      <html.div style={[Style.row, Style.alignCenter, styles.inner]}>
        <html.div style={[Style.row, Style.alignCenter, styles.left]}>
          {left}
        </html.div>
        <html.div style={[Style.row, Style.alignCenter, styles.right]}>
          {children}
        </html.div>
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  bar: {
    position: 'fixed',
    left: {
      default: 200,
      '@media (max-width: 768px)': 0,
    },
    right: 0,
    bottom: 0,
    backgroundColor: color.neutral0,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: color.neutral20,
    boxShadow: '0 -2px 12px rgba(31, 36, 51, 0.08)',
    zIndex: 500,
  },
  inner: {
    gap: 12,
    justifyContent: 'space-between',
    maxWidth: 800,
    margin: '0 auto',
    width: '100%',
    paddingBlock: 16,
    paddingInline: {
      default: 32,
      '@media (max-width: 768px)': 16,
    },
  },
  left: {
    flexGrow: 1,
    gap: 12,
  },
  right: {
    gap: 8,
  },
});
